<template>
    <section>
        <grid-component
            :gridId="gridId"
            :itemData="itemData"
            :fields="fields"
            :handleRowClick="onEdit"
            :styleCustom="'height: 160px'"
        />

        <b-modal
            id="edit-inspection-modal"
            ref="edit-inspection-modal"
            size="xl"
            hide-footer
            centered
            header-close-label="Cancel"
            :title="`Manage Report - ${inspectionReportTypeName}`"
            scrollable
        >
            <AddFormWizard
                :reportName="reportName"
                :inventoryDetails="{...inventoryDetails, quantitySold: (!isRma) ? inventoryDetails.quantity : inventoryDetails.qtyReturning}"
                :inspectionDetails="inspectionDetails"
                :rmaLinePartId="rmaLinePartId"
                @getReports="refreshData"
                :onRmaInspection="isRma"
            />
        </b-modal>

    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import GridComponent from '@/shared/components/GridComponent';
import fields from '@/pages/InspectionReports/fields';
import { GRID_ID } from '@/shared/constants';
import AddFormWizard from '@/shared/components/InspectionReport/components/Form/AddFormWizard';
export default {
    components: {
        GridComponent,
        AddFormWizard
    },
    props: {
        purchaseOrderLineId: {
            type: [Number, String],
            default: 0
        },
        rmaLineId: {
            type: [Number, String],
            default: 0
        },
        partId: {
            type: [Number, String],
            default: 0
        },
        rmaLinePartId: {
            type: [Number, String],
            default: 0
        }
    },
    data() {
        return {
            fields,
            gridId:GRID_ID.INSPECTION_REPORTS_LOWER_TAB,
            inspectionReportTypeName: null,
            reportName: null,
            isRma: false,
            inspectionDetails: {}
        }
    },
    computed: {
        ...mapGetters('inspectionReports', ['inspectionReportsListByPoLine', 'inspectionReportsListByPart', 'rmaInspectionReportsList']),
        ...mapGetters('inventory', ['inventoryDetails']),
        itemData() {
            return (this.purchaseOrderLineId) ? this.inspectionReportsListByPoLine
                : (this.partId) ? this.inspectionReportsListByPart
                : (this.rmaLineId) ? this.rmaInspectionReportsList : [];
        }
    },
    methods: {
        ...mapActions('inspectionReports', ['getInspectionByPurchaseOrderLine', 'getInspectionByPart', 'getRmaInspection']),
        ...mapActions('inventory', ['getById']),
        isGetInventoryDetails(id) {
            return (Object.keys(this.inventoryDetails).length == 0 || this.inventoryDetails.id != id);
        },
        showAlert() {
            this.openAlertBox({ message: 'No Inventory Record Found' }).then(() => {
                this.$bvModal.hide('edit-inspection-modal');
            })
        },
        async onEdit({ dataItem }){
            if (dataItem.inventoryId > 0) {
                if (this.isGetInventoryDetails(dataItem.inventoryId)) {
                    this.getById(dataItem.inventoryId).then(() => {
                        if (this.isGetInventoryDetails(dataItem.inventoryId)) {
                            this.showAlert();
                            return;
                        }
                    });
                }

                switch(dataItem.inspectionReportTypeName) {
                    case 'Default':
                        this.inspectionReportTypeName = 'Aegis Inspection';
                        this.reportName = 'DefaultInspection';
                        this.isRma = false;
                        break;
                    case 'IDEA':
                        this.inspectionReportTypeName = 'IDEA Inspection';
                        this.reportName = 'IdeaInspection';
                        this.isRma = false;
                        break;
                    case 'RMA':
                        this.inspectionReportTypeName = 'RMA Inspection';
                        this.reportName = 'RmaInspection';
                        this.isRma = true;
                        break;
                }

                this.inspectionDetails = dataItem;
                this.$bvModal.show('edit-inspection-modal')
            } else {
                this.showAlert();
            }
        },
        async getData() {
            if (this.purchaseOrderLineId) {
                await this.getInspectionByPurchaseOrderLine(this.purchaseOrderLineId);
            } else if (this.partId) {
                await this.getInspectionByPart(this.partId);
            } else if (this.rmaLineId) {
                await this.getRmaInspection(this.rmaLineId);
            }
        },
        refreshData() {
			this.$bvModal.hide('edit-inspection-modal')
            this.getData();
        },
    },
    watch: {
        purchaseOrderLineId() {
            this.getData();
        },
        partId() {
            this.getData();
        },
        rmaLineId() {
            this.getData();
        }
    }
}
</script>

<style>

</style>